import { useAppSelector } from 'modules/Editor/store';
import { selectPageOrder } from 'modules/Editor/store/infographSelector';
import { CSSProperties, ReactNode } from 'react';

import { PAGE_LINK_PREFIX } from './widgetSdk.config';

type LinkWrapperProps = {
  children: ReactNode;
  style?: CSSProperties;
  hyperlink?: string;

  // If true, will keep href as is, otherwise, will modify for page links to #page-<pageId>
  shouldKeepLink?: boolean;
};

export const LinkWrapper = ({ children, hyperlink, style, shouldKeepLink }: LinkWrapperProps) => {
  if (hyperlink) {
    if (hyperlink.startsWith(PAGE_LINK_PREFIX)) {
      return (
        <LinkWithPageLink hyperlink={hyperlink} style={style} shouldKeepLink={shouldKeepLink}>
          {children}
        </LinkWithPageLink>
      );
    } else {
      return (
        <LinkWithHyperlink hyperlink={hyperlink} style={style}>
          {children}
        </LinkWithHyperlink>
      );
    }
  }

  return <>{children}</>;
};

const LinkWithHyperlink = ({ children, hyperlink, style }: LinkWrapperProps) => {
  return (
    <a href={hyperlink} rel='noreferrer nofollow' target='_blank' style={style}>
      {children}
    </a>
  );
};

const LinkWithPageLink = ({ children, hyperlink, style, shouldKeepLink }: LinkWrapperProps) => {
  const pageOrder = useAppSelector(selectPageOrder);
  const pageId = hyperlink?.replace(PAGE_LINK_PREFIX, '');

  if (!pageId || !pageOrder.includes(pageId)) {
    return <>{children}</>;
  }

  return (
    <a href={shouldKeepLink ? hyperlink : `#page-${pageId}`} target='_self' data-page-id={pageId} style={style}>
      {children}
    </a>
  );
};
